import React, { useContext } from 'react'
import { Navigate, useLocation } from 'react-router'
import { Loader } from 'semantic-ui-react'
import { URLHelper, ViewerContext } from 'shared'

export const useRedirectIfSignedIn = () => {
  const location = useLocation()
  const { viewer, viewerLoading } = useContext(ViewerContext)
  if (viewerLoading) return <Loader active />
  if (viewer) return <Navigate replace to={URLHelper.returnToPath(location)} />
  return null
}
